<template>
    <div class="modal-edicao mb-3 modal-edicao-label mt-6">
		<EditAccount
			v-if="modalAccount"
			:accountData="{}"
			@closeModal="closeAccount"
			@newAccount="setAccount"
			:name="nameAccount"
		/>
		<EditCategoryExpenses
			v-if="modalCategory"
			:categoryExpenseData="{}"
			@closeModal="closeCategory"
			@newCategoryExpense="setCategory"
			:name="nameCategory"
		/>
        <b-row class="filters-orientation">
			<b-col v-if="!editing && !hideRecurring" cols="2" class="text-parcela" style="text-align: center;">
				<label class="label-conta mb-0">Recurrente</label>
				<div class="toggle-div mr-3" style="width: 100%; align-items: center; margin-top: -4px !important;">
					<ToggleSwitch
						name="isSchedulingRecurring"
						class="toggle"
						:value="isSchedulingRecurring"
						@toggle="_ => changeToggle('isSchedulingRecurring')"
					/>
				</div>
			</b-col>
            <b-col class="text-parcela">
				<label v-if="isSchedulingRecurring" class="label-parcela">Data Inicial</label>
                <label v-else class="label-parcela">Data Lançamento</label>
                <div class="d-flex">
                    <datepicker
						name="createDate"
                        class="w-100"
                        placeholder=""
                        id="data-lancamento"
                        input-class="bg-white"
                        v-model="transactionUpsert_date"
                        :format="formatter"
                        :language="ptBR"
                        :bootstrap-styling="true"
                        data-cy="Data Lançamento"
                        :disabled="loading || editing || (isSchedulingRecurring && editing)"
						@input="validateAccountClass()"
                    />
                </div>
            </b-col>
            <b-col v-if="!multiEdit" class="text-parcela">
				<label v-if="isSchedulingRecurring" class="label-parcela">Data Final</label>
                <label v-else class="label-parcela">Data Vencimento</label>
                <div class="d-flex">
                    <datepicker
						name="expireDate"
                        class="w-100"
                        placeholder=""
                        id="data-pagamento"
                        input-class="bg-white"
                        v-model="transactionUpsert_paymentDate"
                        :format="formatter"
                        :language="ptBR"
                        :bootstrap-styling="true"
                        data-cy="Data Pagamento"
                        :disabled="(disablePaymentDate || loading) && !isSchedulingRecurring"
						:value-as-date="false"
						:disabled-dates="disabledEndDates"
                    />
					<div
						v-if="isSchedulingRecurring"
						class="filter icon-delete"
						v-bind:class="!transactionUpsert_paymentDate ? 'filter-disable' : ''"
						@click="clearData('transactionUpsert_paymentDate')"
						title="Limpar"
					>
						<Trash2Icon/>
					</div>
                </div>
            </b-col>
        </b-row>
        <b-row class="filters-orientation">
            <b-col class="text-parcela mb-2">
                <span class="label-conta">
                    Beneficiário/Credor
                </span>
				<SearchSelect
					:key="'account'"
					name="account"
					:options="account.filter(item => !item.inactive && !item.permitePagamento)"
					:visibleSuggestion="visibleSuggestion.account"
					:isMobile="isMobile"
					:newRecord="newAccount"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
					:disabled="loading || editing"
				/>
            </b-col>
            <b-col v-if="permitPay && !editing" cols="4" class="text-parcela mb-2">
                <span class="label-conta">Balance</span>
                <b-form-input
                    name="accountBalance"
                    class="modal-edicao-input number-class"
                    v-model="accountBalance"
                    :disabled="true"
                />
            </b-col>
			<b-col class="text-parcela">
                <span class="label-conta">
                    Categoria da Transação
                </span>
				<SearchSelect
					:key="'category'"
					name="category"
					:options="category.filter(item => !item.inactive)"
					:visibleSuggestion="visibleSuggestion.category"
					:isMobile="isMobile"
					:newRecord="newCategory"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
					:disabled="loading || editing"
				/>
            </b-col>
        </b-row>
        <Installment v-if="!multiEdit && !isSchedulingRecurring"
            :editing="editing"
            :date="transactionUpsert_paymentDate"
            @setNewValue="setNewAmount"
            @dataInstallments="setDataInstallments"
            :update="updateInstallments"
            :dateIsFirstInstallment="true"
            :dateDisabled="true"
            @errorInstallments="validateInstallments"
            :hideSelectInterval="true"
            :hideSelectSendMsg="true"
            :dayPay="transactionUpsert_paymentDate.getDate()"
            :disableInstallment="!permitInstallments"
            :totalAmount="editing ? parseFloat(transactionUpsert_amount) : 0"
            :clearFields="clearFields"
            :hideInstallment="!permitInstallments"
			:disableAmount="disableAmount"
        />
		<InstallmentsEdit v-else-if="!isSchedulingRecurring"
			:dataEdit="editRows"
			@invalidData="validateInstallments"
			@dataEditInstallments="setDataMultiEdit"
			:hideSelectSendMsg="true"
		/>
		<div v-else>
			<SchedulingRecurring
				@data="setDataRecurrent"
				@error="validateInstallments"
				:clearFields="clearFields"
				:disabled="saving || loading"
				:strAmount="editing ? transactionUpsert_amount : '0'"
				:intervalEdit="transactionDocument.interval ? transactionDocument.interval.toString() : null"
				:dayOfWeekEdit="transactionDocument.dayOfWeek ? transactionDocument.dayOfWeek.toString() : null"
				:selectedFrequencyEdit="transactionDocument.frequency || null"
				:dayOfMonthEdit="transactionDocument.dayOfMonth ? transactionDocument.dayOfMonth.toString() : null"
			/>
		</div>
        <b-row class="mt-2 filters-orientation">
            <b-col v-if="!multiEdit && !isSchedulingRecurring" class="d-block text-parcela">
                <span class="label-conta">Referência</span>
                <b-form-input
                    name="reference"
                    class="modal-edicao-input"
                    v-model="transactionUpsert_reference"
                    autocomplete="off"
                    placeholder=""
                    v-validate="'maxLength:100'"
                    :state="validateState('reference')"
                />
            </b-col>
            <b-col class="d-block text-parcela">
				<span v-if="isSchedulingRecurring" class="label-conta">Descrição</span>
                <span v-else class="label-conta">Observações</span>
                <b-form-input
                    name="comments"
                    class="modal-edicao-input"
                    v-model="transactionUpsert_comments"
                    autocomplete="off"
                    placeholder=""
                    v-validate="'maxLength:255'"
                    :state="validateState('comments')"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { possuiPermissao } from "../../helpers/permissions";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue, formatterSimple } from "@/helpers/common";
	import { PaymentScheduleService } from "../../services/paymentSchedule";
	import Installment from "@/components/Installment.vue";
	import InstallmentsEdit from "@/components/InstallmentsEdit.vue";
	import { mapState } from "vuex";
	import EditAccount from "@/views/Account/EditAccount.vue";
	import EditCategoryExpenses from "@/views/CategoryExpenses/EditCategoryExpenses.vue";
	import SearchSelect from "@/components/SearchSelect.vue";
	import ToggleSwitch from "@/components/ToggleSwitch.vue";
	import SchedulingRecurring from "@/components/SchedulingRecurring.vue";
	import { SchedulingRecurringService } from "../../services/schedulingRecurring";

	import "./styles.css";

	export default {
		name: "FormTopay",
		components: {
			Datepicker,
			Installment,
			InstallmentsEdit,
			EditAccount,
			EditCategoryExpenses,
			SearchSelect,
			ToggleSwitch,
			SchedulingRecurring
		},

		props: {
			transactionDocument: {
				type: Object,
				required: true
			},
			toSave: {
				type: Boolean,
				required: true
			},
			clearFields: {
				type: Boolean,
				required: true
			},
			isMobile: {
				type: Boolean,
				required: false
			}
		},
		data () {
			return {
				possuiPermissao,
				ready: true,
				loading: false,
				ptBR,

				editRows: [],
				originalRows: [],

				transactionUpsert_idPaymentSchedule: null,
				transactionUpsert_comments: "",
				transactionUpsert_idCategory: null,
				transactionUpsert_idAccountExpense: null,
				transactionUpsert_date: new Date(),
				transactionUpsert_amount: 0,
				transactionUpsert_amount_string: "0,00",
				transactionUpsert_reference: "",

				paymentPayloadObject: {},

				transactionUpsert_valor: 0,
				transactionUpsert_valor_string: "0,00",

				transactionUpsert_paymentDate: new Date(),
				permitInstallments: false,
				multiEdit: false,
				updateInstallments: true,
				permitPay: false,
				disablePaymentDate: false,
				errorInstallments: true,

				editing: false,
				saving: false,
				invalidForm: true,
				accountBalance: "0,00",
				insufficientBalance: false,
				paymentScheduleService: new PaymentScheduleService(),
				disableAmount: false,

				accountOptions: [],
				categoryOptions: [],
				modalAccount: false,
				modalCategory: false,
				visibleSuggestion: {
					account: false,
					category: false
				},
				nameAccount: "",
				nameCategory: "",
				invalidSearch: {
					account: true,
					category: true
				},
				newCategory: {},
				newAccount: {},
				clearSelect: false,
				isSchedulingRecurring: false,
				transactionUpsert_idSchedulingRecurring: null,
				schedulingRecurringService: new SchedulingRecurringService(),
				hideRecurring: false,
				disabledEndDates: {}
			};
		},

		watch: {
			toSave () {
				if (this.toSave) this.save();
			},
			clearFields () {
				if (this.clearFields)
					this.clearModal();
			}
		},

		computed: mapState(["account", "category", "accountClass"]),

		async mounted () {
			const today = new Date();
			this.disabledEndDates = {
				to: new Date(today.getTime() - 1)
			};

			if (this.transactionDocument.idSchedulingRecurring) {
				this.hideRecurring = true;
				this.isSchedulingRecurring = true;
			}

			if (this.transactionDocument.idPaymentSchedule || this.transactionDocument.idSchedulingRecurring) {
				if (this.transactionDocument.UUID && this.transactionDocument.installments > 1) {
					const filters = {
						UUID: this.transactionDocument.UUID
						// status: "Em aberto"
					};
					const result = await this.paymentScheduleService.getPaymentScheduleInstallmentsActive(filters) || {};

					this.editRows = result.rows.reduce((acc, c) => [
						...acc,
						{
							idPaymentSchedule: c.idPaymentSchedule,
							paymentDate: formatterSimple(c.paymentDate),
							fullDate: c.paymentDate,
							amount: numberFormatted(c.amount).replace(".", ""),
							reference: c.reference || "",
							comments: c.comments,
							idAccountSchedule: c.idAccountSchedule,
							idCategoryExpense: c.idCategoryExpense,
							date: c.date,
							paid: c.status === "PAID"
						}
					], []);
					this.originalRows = JSON.stringify(this.editRows);
					this.multiEdit = this.editRows.length > 1;
				}

				this.transactionUpsert_idPaymentSchedule = this.transactionDocument.idPaymentSchedule;
				this.transactionUpsert_idSchedulingRecurring = this.transactionDocument.idSchedulingRecurring;
				this.transactionUpsert_comments = this.transactionDocument.comments || "";
				this.transactionUpsert_idCategory = this.transactionDocument.idCategory;
				this.transactionUpsert_idAccountExpense = this.transactionDocument.idAccount;
				this.transactionUpsert_date = new Date(this.transactionDocument.transactionDate);
				this.transactionUpsert_paymentDate = this.transactionDocument.scheduleDate ? new Date(this.transactionDocument.scheduleDate) : null;
				this.transactionUpsert_amount_string = numberFormatted(this.transactionDocument.transactionAmount);
				this.transactionUpsert_amount = this.transactionDocument.transactionAmount;
				this.transactionUpsert_reference = this.transactionDocument.reference;
				this.editing = true;
				this.disableAmount = this.transactionDocument.status === "PAID";
				this.newCategory = {
					id: this.transactionDocument.idCategory,
					description: this.transactionDocument.categoryName
				};
				this.newAccount = {
					id: this.transactionDocument.idAccount,
					description: this.transactionDocument.accountName
				};
			}
		},

		methods: {
			getStateClosedAccount (date_, closingDay, closeNextDayWeekend) {
				const date = new Date(date_);
				const month = date.getMonth(date_);
				let day = date.getDate(); // obtem dia do lançamento
				if (!this.bestShoppingDay) {
					date.setDate(date.getDate() - 1);
					day = date.getDate();
				}

				const dateClosing = new Date(this.transactionUpsert_date);
				const monthClosing = date.getMonth(dateClosing);

				if (day >= closingDay && month == monthClosing) return true;

				dateClosing.setDate(closingDay);
				const weekDayClosingAccount = dateClosing.getDay();
				if (closeNextDayWeekend && (weekDayClosingAccount === 0 || weekDayClosingAccount === 6)) {
					switch (weekDayClosingAccount) {
						case 0:
							day = day + 2;
							break;
						case 6:
							day = day + 1;
							break;
					}
					if (day >= closingDay && month == monthClosing) return true;
				}
				return false;
			},

			addMonth (month, year) {
				if (month == 11) {
					this.transactionUpsert_paymentDate.setMonth(0);
					this.transactionUpsert_paymentDate.setFullYear(year + 1);
				} else {
					this.transactionUpsert_paymentDate.setMonth(month + 1);
				}
			},

			setNewAmount (value) {
				this.transactionUpsert_valor = value;
				this.transactionUpsert_valor_string = numberFormatted(value);
				this.updateInstallments = false;
			},

			setDataInstallments (data) {
				this.transactionUpsert_valor = data.outstandingBalance;
				this.paymentPayloadObject = {
					valor: data.outstandingBalance,
					amount: data.toReceiveDataInstallments.map(installment => installment.amount),
					installments: data.installments
				};
			},

			setDataRecurrent (data) {
				this.paymentPayloadObject = {
					...data
				};
			},

			setDataMultiEdit (data) {
				const { dataEdited } = data;
				const original = this.originalRows ? JSON.parse(this.originalRows) : null;
				const modifiedRows = [];
				dataEdited.forEach((row, idx) => {
					const haveAlter = row.paymentDate !== original[idx].paymentDate
						|| row.amount !== original[idx].amount
						|| row.reference !== original[idx].reference
						|| row.comments !== this.transactionUpsert_comments
						|| row.idAccountSchedule !== this.transactionUpsert_idAccountExpense
						|| row.idCategoryExpense !== this.transactionUpsert_idCategory
						|| !this.isModifiedDate(new Date(row.date), new Date(this.transactionUpsert_date));

					if (haveAlter) {
						const modifiedrow = {
							idPaymentSchedule: row.idPaymentSchedule
						};
						if (row.paymentDate !== original[idx].paymentDate) {
							const dateArray = row.paymentDate.split("-");
							const date = new Date(original[idx].fullDate);
							date.setFullYear(dateArray[2]);
							date.setMonth(dateArray[1] - 1);
							date.setDate(dateArray[0]);
							modifiedrow.paymentDate = date;
						}

						if (row.amount !== original[idx].amount)
							modifiedrow.amount = row.amount.replace(".", "").replace(",", ".");

						if (row.reference !== original[idx].reference)
							modifiedrow.reference = row.reference;

						if (row.comments !== this.transactionUpsert_comments)
							modifiedrow.comments = this.transactionUpsert_comments;

						if (row.idAccountSchedule !== this.transactionUpsert_idAccountExpense)
							modifiedrow.idAccountSchedule = this.transactionUpsert_idAccountExpense;

						if (row.idCategoryExpense !== this.transactionUpsert_idCategory)
							modifiedrow.idCategoryExpense = this.transactionUpsert_idCategory;

						if (!this.isModifiedDate(new Date(row.date), new Date(this.transactionUpsert_date))) {
							modifiedrow.date = this.transactionUpsert_date;
						}

						modifiedRows.push(modifiedrow);
					}

				});

				this.paymentPayloadObject = modifiedRows;
			},

			validateInstallments (valid) {
				this.errorInstallments = valid;
				this.$emit("invalidForm", Boolean(valid || this.invalidForm));
			},

			async updateValue (value) {
				this.transactionUpsert_amount_string = await validateNumber(value);
				this.transactionUpsert_amount = this.transactionUpsert_amount_string.replace(",", ".");
			},

			closeSelectTransaction () {
				this.$emit("closeSelectTransaction", true);
			},

			closeFormTransaction () {
				this.$emit("closeFormTransaction", true);
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			handleFocus (key) {
				if (isNullValue(this[key])) this[key] = "";
				else this[key] = this[key].replace(/\./g, "");
			},

			handleBlur (key) {
				if (this[key]) {
					this[key] = numberFormatted(stringToNumber(this[key]));
				}
			},

			async save () {
				if (!this.multiEdit) {
					this.paymentPayloadObject.comments = this.transactionUpsert_comments;
					this.paymentPayloadObject.reference = this.transactionUpsert_reference;
					this.paymentPayloadObject.idCategoryExpense = this.transactionUpsert_idCategory;
					this.paymentPayloadObject.idAccountSchedule = this.transactionUpsert_idAccountExpense;
					this.paymentPayloadObject.automaticPay = this.permitPay;
					this.paymentPayloadObject.date = this.transactionUpsert_date;
					this.paymentPayloadObject.idPaymentSchedule = this.transactionUpsert_idPaymentSchedule;
					this.paymentPayloadObject.paymentDate = this.transactionUpsert_paymentDate;
					this.paymentPayloadObject.isSchedulingRecurring = this.isSchedulingRecurring;
					this.paymentPayloadObject.idSchedulingRecurring = this.transactionUpsert_idSchedulingRecurring;
				}

				this.saving = true;
				const payload = this.paymentPayloadObject;

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						if (payload.isSchedulingRecurring) {
							if (payload.idSchedulingRecurring) {
								await this.schedulingRecurringService.updateSchedulingRecurring({payload});
							} else {
								payload.transactionType = "TOPAY";
								payload.status = "ACTIVE";
								await this.schedulingRecurringService.createSchedulingRecurring({payload});
							}

						} else if (this.multiEdit) {
							if (payload.length)
								await this.paymentScheduleService.updateMultiRecords({payload});

						} else if (payload.idPaymentSchedule) {
							await this.paymentScheduleService.updatePaymentSchedule({payload});
						} else {
							payload.transactionType = "TOPAY";
							payload.status = "ACTIVE";
							await this.paymentScheduleService.createPaymentSchedule({payload});
						}

						this.clearModal();
						this.$emit("saved", true);
						this.saving = false;

						return {
							title: "Sucesso!",
							body: "Transação salva com sucesso.",
							config
						};
					} catch (error) {
						this.$emit("saved", false);
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			clearModal () {
				this.transactionUpsert_idPaymentSchedule = null;
				this.transactionUpsert_comments = "";
				this.transactionUpsert_reference = "";
				this.transactionUpsert_idCategory = null;
				this.transactionUpsert_idAccountExpense = null;
				this.transactionUpsert_date = new Date();
				this.transactionUpsert_amount_string = "0,00";
				this.transactionUpsert_amount = 0;
				this.saving = false;
				this.editing = false;
				this.invalidForm = true;
				this.accountBalance = "0,00";
				this.insufficientBalance = false;
				this.disableAmount = false;
				this.clearSelect = !this.clearSelect;
				if (this.isSchedulingRecurring) {
					this.transactionUpsert_paymentDate = null;
				}

				this.$emit("clearedFields", true);
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields) || this.invalidSearch.account || this.invalidSearch.category;
				this.$emit("invalidForm", Boolean(this.errorInstallments || this.invalidForm));
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			validateAccountClass () {
				if (this.editing || this.isSchedulingRecurring) return;

				const accountSelected = this.account.filter(a => a.value === this.transactionUpsert_idAccountExpense);

				if (accountSelected.length) {
					this.disablePaymentDate = Boolean(accountSelected[0].closingDay !== accountSelected[0].payDay);
					this.permitInstallments = accountSelected[0].permiteParcelas;
					this.permitPay = accountSelected[0].permitePagamento;

					const paymentDate = accountSelected[0].payDay || accountSelected[0].closingDay;
					let month = this.transactionUpsert_date.getMonth(); // obtem mes do lançamento
					const year = this.transactionUpsert_date.getFullYear(); // obtem ano do lançamento

					if (accountSelected[0].closingDay && !this.permitPay) {
						const accountClosed = this.getStateClosedAccount(
							this.transactionUpsert_date,
							accountSelected[0].closingDay,
							accountSelected[0].closeNextDayWeekend
						);
						// Caso dia de cierre es mayor que dia de pago
						// el sistema debe entender qie cierra en una mes y vence en el siguiente
						// Por tal motivo debe ser adicionado un mes mas para el agendamiento
						if (accountSelected[0].closingDay > accountSelected[0].payDay)
							month = month + 1;

						this.transactionUpsert_paymentDate = new Date(this.transactionUpsert_paymentDate.setDate(paymentDate));
						if (accountClosed) {
							this.addMonth(month, year);
							month = this.transactionUpsert_date.getMonth();
						} else {
							this.transactionUpsert_paymentDate.setMonth(month);
						}
					} else {
						this.transactionUpsert_paymentDate = new Date(this.transactionUpsert_date);
					}
				} else {
					this.permitInstallments = null;
					this.permitPay = null;
					this.transactionUpsert_paymentDate = new Date(this.transactionUpsert_date);
				}

				if (!this.permitInstallments || !this.transactionUpsert_installments) {
					this.transactionUpsert_installments = 1;
					this.transactionUpsert_amount = [ this.transactionUpsert_valor ];
				}

				if (this.permitInstallments && this.transactionUpsert_installments > 1)
					this.setInstallments();

			},

			isModifiedDate (date1, date2) {
				return (
					date1.getFullYear() === date2.getFullYear() &&
					date1.getMonth() === date2.getMonth() &&
					date1.getDate() === date2.getDate()
				);
			},

			showAccount () {
				this.modalAccount = true;
			},

			closeAccount (cancelled) {
				if (cancelled) {
					this.nameAccount = "";
				}

				this.modalAccount = false;
			},

			setAccount (newAccount) {
				this.newAccount = {
					id: newAccount[0].idAccount,
					description: newAccount[0].description
				};
				const automaticPay = (this.accountClass.find(ac => ac.idAccountClass === newAccount[0].idAccountClass)).automaticPay || null;
				if (newAccount.inactive || automaticPay) {
					this.newAccount.notPermited = true;
				}
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				if (value) {
					if (fatherComponent === "account") {
						this.transactionUpsert_idAccountExpense = value;
						this.nameAccount = text;
						this.validateAccountClass();
					} else {
						this.transactionUpsert_idCategory = value;
						this.nameCategory = text;
					}
				} else {
					if (fatherComponent === "account") {
						this.nameAccount = text;
						this.showAccount();
					} else {
						this.nameCategory = text;
						this.showCategory();
					}
				}
			},

			showCategory () {
				this.modalCategory = true;
			},

			closeCategory (cancelled) {
				if (cancelled) {
					this.nameCategory = "";
				}

				this.modalCategory = false;
			},

			setCategory (newCategoryExpense) {
				this.newCategory = {
					id: newCategoryExpense[0].idCategoryExpense,
					description: newCategoryExpense[0].description
				};
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
				if (validateSearch.fatherComponent === "account" && validateSearch.invalidSearch && !this.editing) {
					this.transactionUpsert_idAccountExpense = null;
					if (!this.isSchedulingRecurring) {
						this.transactionUpsert_paymentDate = new Date(this.transactionUpsert_date);
					}
					this.permitInstallments = false;
				}
			},

			handleVisibleSuggestion (handleSuggestion) {
				if (handleSuggestion.visibleSuggestion) {
					const visibleSuggestionKeys = Object.keys(this.visibleSuggestion);
					visibleSuggestionKeys.forEach((vsk) => {
						if (vsk === handleSuggestion.name) {
							this.visibleSuggestion[vsk] = handleSuggestion.visibleSuggestion;
						} else {
							this.visibleSuggestion[vsk] = false;
						}
					});
				} else {
					this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
				}
			},

			changeToggle (key) {
				this[key] = !this[key];
				if (key === "isSchedulingRecurring") {
					if (this[key]) {
						this.transactionUpsert_paymentDate = null;
					} else {
						if (this.transactionUpsert_idAccountExpense) {
							this.transactionUpsert_date = new Date();
							this.transactionUpsert_paymentDate = new Date();
							this.validateAccountClass();
						} else {
							this.transactionUpsert_paymentDate = new Date(this.transactionUpsert_date);
						}
					}
				}
			},

			clearData (key) {
				this[key] = null;
			}
		}
	};

</script>

<style scoped>
.icon-delete {
	margin-top: -3px;
	margin-left: 3px;
	display: flex;
	justify-content: center;
	background-color: red;
	color: white;
	padding: 2px;
}
</style>